import { getCurrentScope as o, onScopeDispose as n, unref as r } from "vue";
function f(e) {
  return o() ? (n(e), !0) : !1;
}
function p(e) {
  return typeof e == "function" ? e() : r(e);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
export {
  p as toValue,
  f as tryOnScopeDispose
};
